<template>
  <div>
    <div class="inner-content">
      <h2>{{ $t('notification') }}</h2>
      <div class="news-area">
        <ul>
          <li v-for="item in pageOfItems" :key="item.id">
            <p class="txt-date">{{ item.displayDate }}</p>
            <p class="txt-news" data-private>
              <a href="javascript:;" @click="onShow(item)">{{ item.title }}</a>
            </p>
          </li>
        </ul>
      </div>
      <div class="pager-area">
        <Pagination :items="notifications" v-on:changePage="changePage" :initialPage="currentPage" :pageSize="pageSize"/>
      </div>
    </div>
    <template v-if="$store.state.auth.typeOfUser === 'doctor'">
      <SurveyBanner v-on:isShowBanner="isShowBanner"/>
    </template>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex"
import SurveyBanner from '@/js/components/Common/SurveyBanner'
import Pagination from '@/js/components/Common/Pagination'
export default {
  components: {
    Pagination, SurveyBanner
  },
  data() {
    return {
      pageOfItems: [],
      pageSize: 10,
      windowHeight: 0,
      isHaveBanner: false
    }
  },
  watch: {
    isHaveBanner() {
      this.handleResize()
    }
  },
  computed: {
    ...mapState({
      notifications: state => state.notification.notifications,
      currentPage: state => state.notification.currentPage,
    })
  },
  async mounted() {
    this.screenTracking(this.$t('notice_list'))
    await this.$store.dispatch('notification/getNotifications') 
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  methods: {
    handleResize() {
      this.windowHeight = $(window).height()
      //50: header
      //67: title 27 + margin 40
      //40: padding
      //76: item 56 + margin 20 
      //43: paginate
      //130: survey banner 100 + margin 30
      //43: footer
      let newsAreaHeight = this.windowHeight - 50 - 67 - 40 - 43 - 43 - (this.isHaveBanner ? 130 : 0)
      this.pageSize = Math.floor(newsAreaHeight/76) > 10 ? 10 : Math.floor(newsAreaHeight/76)
    },
    changePage(pageOfItems) {
      this.pageOfItems = pageOfItems
    },
    async onShow(item) {
      await this.$store.dispatch('notification/setNotificationDetail', item)
      this.$router.push({ path: '/notifications/detail' })
    },
    isShowBanner(value) {
      this.isHaveBanner = value
    },
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>